import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const Step2EmergencyContact = ({ formData, handleChange }) => {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-2xl font-bold text-gray-900 mb-2">Emergency Contact & Self-Identification</h3>
        <p className="text-gray-600">Provide emergency contact information</p>
      </div>

      {/* Emergency Contact */}
      <div className="bg-gray-50 p-6 rounded-lg space-y-4">
        <h4 className="font-bold text-lg">Emergency Contact Information</h4>
        
        <div>
          <Label htmlFor="emergency_contact_name">Emergency Contact Name *</Label>
          <Input
            id="emergency_contact_name"
            value={formData.emergency_contact_name}
            onChange={(e) => handleChange('emergency_contact_name', e.target.value)}
            required
          />
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <Label htmlFor="emergency_relationship">Relationship to Applicant *</Label>
            <Input
              id="emergency_relationship"
              value={formData.emergency_relationship}
              onChange={(e) => handleChange('emergency_relationship', e.target.value)}
              required
            />
          </div>
          <div>
            <Label htmlFor="emergency_phone">Telephone Number *</Label>
            <Input
              id="emergency_phone"
              type="tel"
              value={formData.emergency_phone}
              onChange={(e) => handleChange('emergency_phone', e.target.value)}
              required
            />
          </div>
        </div>
      </div>

      {/* Voluntary Self-Identification */}
      <div className="bg-blue-50 p-6 rounded-lg space-y-4">
        <h4 className="font-bold text-lg">Voluntary Self-Identification (Optional)</h4>
        <p className="text-sm text-gray-600">
          Completion of this section is voluntary and will not be used in the hiring decision. 
          Information is collected for equal employment opportunity reporting purposes only.
        </p>

        <div>
          <Label htmlFor="race_ethnicity">Race/Ethnicity</Label>
          <select
            id="race_ethnicity"
            value={formData.race_ethnicity}
            onChange={(e) => handleChange('race_ethnicity', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
          >
            <option value="">Select...</option>
            <option value="not_disclosed">I choose not to disclose</option>
            <option value="american_indian">American Indian or Alaska Native</option>
            <option value="asian">Asian</option>
            <option value="black">Black or African American</option>
            <option value="hispanic">Hispanic or Latino</option>
            <option value="native_hawaiian">Native Hawaiian or Other Pacific Islander</option>
            <option value="white">White</option>
            <option value="two_or_more">Two or More Races</option>
            <option value="other">Other</option>
          </select>
        </div>

        {formData.race_ethnicity === 'other' && (
          <div>
            <Label htmlFor="race_other">Please specify</Label>
            <Input
              id="race_other"
              value={formData.race_other}
              onChange={(e) => handleChange('race_other', e.target.value)}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Step2EmergencyContact;